/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionGridQueryResponse,
  GetApiV1ExamRevisionGridQueryParams,
  GetApiV1ExamRevisionGrid401,
  GetApiV1ExamRevisionGrid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionGrid.ts";

function getGetApiV1ExamRevisionGridUrl() {
  const res = { method: "GET", url: `/api/v1/exam/revision/grid` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de provas geradas por bot, ordenadas pela data de início da aula de forma decrescente. Suporta filtros opcionais por disciplina, turma de aluno e data exata de realização da aula. **(Requer Authorization para autenticação)**
 * @summary Listar provas geradas por IA no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/grid}
 */
export async function getApiV1ExamRevisionGrid(
  params?: GetApiV1ExamRevisionGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionGridQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamRevisionGrid401 | GetApiV1ExamRevisionGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionGridUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
